import { render, staticRenderFns } from "./CompanyServiceSearch.vue?vue&type=template&id=1ffba0aa&"
import script from "./CompanyServiceSearch.vue?vue&type=script&lang=js&"
export * from "./CompanyServiceSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports